import { AdditionalRequestState, REQUEST_STATE } from "../dataTypes";

const mapFulfilledResponseObject = <T>(responseObject: T): T & AdditionalRequestState => {
  return { ...responseObject, requestStatus: REQUEST_STATE.FULFILLED, errorMessage: undefined };
};

export default mapFulfilledResponseObject;
